import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export default function SectionShell({
  title,
  icon: Icon,
  titleClassName = "",
  collapsible = false,
  defaultCollapsed = true,
  children,
}) {
  const [expanded, setExpanded] = useState(collapsible ? !defaultCollapsed : true);

  const titleContent = (
    <>
      {Icon ? <Icon className="w-5 h-5 mr-2 shrink-0" /> : null}
      {title}
    </>
  );

  return (
    <div className="border rounded-lg p-4 sm:p-6">
      {collapsible ? (
        <button
          type="button"
          onClick={() => setExpanded((value) => !value)}
          className="w-full flex items-center justify-between gap-3 text-left hover:opacity-80"
          aria-expanded={expanded}
        >
          <h2 className={`text-lg font-semibold flex items-center ${titleClassName}`}>
            {titleContent}
          </h2>
          {expanded ? (
            <ChevronDown className="w-5 h-5 shrink-0 text-gray-500" aria-hidden />
          ) : (
            <ChevronRight className="w-5 h-5 shrink-0 text-gray-500" aria-hidden />
          )}
        </button>
      ) : (
        <h2 className={`text-lg font-semibold mb-4 flex items-center ${titleClassName}`}>
          {titleContent}
        </h2>
      )}
      {(!collapsible || expanded) && (
        <div className={collapsible ? "mt-4" : undefined}>{children}</div>
      )}
    </div>
  );
}
